import ReportCreationImportSuccessScreen from '@screens/ReportCreation/ReportCreationImportSuccessScreen';

export default ReportCreationImportSuccessScreen;
